<template>
    <div :id="`multiligne${multiligne}`">
      <div class="container sliderMultiligne" >
        <fieldset>
          <legend class="text-bold text-sm lg:text-base leading-20 lg:leading-22 mb-20">Pour qui souhaitez-vous ajouter ce forfait ?</legend>
          <div class="dflex items-center gap mb-20 lg:mb-0">
            <div class="form-check form-check--orange">
              <input @click="selectForfaitMultiligneType" class="form-check-input" type="radio" :name="`pourQui${multiligne}`" :data-multiligne="`${multiligne}`" value="0" :id="`pourQui1-${multiligne}`" checked>
              <label class="form-check-label" :for="`pourQui1-${multiligne}`">Moi</label>
            </div>
            <div class="form-check form-check--orange">
              <input @click="selectForfaitMultiligneType" class="form-check-input" type="radio" :name="`pourQui${multiligne}`" :data-multiligne="`${multiligne}`" :id="`pourQui2-${multiligne}`" value="1" >
              <label class="form-check-label" :for="`pourQui2-${multiligne}`">Un tiers</label>
            </div>
            <button @click="deleteForfait" class="text-bold ml-auto underline hover:no-underline pointer" :id="`deleteforfait${multiligne}`" :data-multiligne="`${multiligne}`" type="button">Supprimer</button>
          </div>
        </fieldset>
      </div>

      <div class="ml-center md:ml-center lg:ml-0 lg:container">
        <div class="sliderPoForfait">
          <div class="splide mb-20" aria-label="Slider offre mobile">
            <div class="splide__track">
              <ul class="splide__list">
                <li v-for="(forfait, index) in sortedForfaits" :key="index" class="splide__slide item relative">
                  <span v-if="forfait.field_type_de_promotion" class="jumperSimple absolute top-0 left-0">
                    <span v-if="forfait.field_type_de_promotion == 1">
                      Ed. Spéciale {{ forfait.field_titre_de_la_promotion }}<sup>*</sup>
                    </span>
                    <span v-if="forfait.field_type_de_promotion == 2">
                      Ed. Limitée {{ forfait.field_titre_de_la_promotion }}<sup>*</sup>
                    </span>
                  </span>
                  <span v-else v-if="forfait.field_etiquette_forfait" class="jumperSimple absolute top-0 left-0">
                    {{ forfait.field_etiquette_forfait }}
                  </span>
                  <span v-if="forfait.field_5g" class="jumper5g jumper5g--light absolute top-0 right-0" :class="colors[forfait.field_couleur_de_fond]?.jumperClass || colors.white.jumperClass"><span>5G</span></span>
                  <div class="pt-40 pb-10 px-20" :class="colors[forfait.field_couleur_de_fond]?.bgClass || colors.white.bgClass">

                    <div class="mb-15">
                      <p class="text-sm text-bold leading-20">Forfait</p>
                      <p class="text-26 text-bold leading-30 mb-10" :class="colors[forfait.field_couleur_de_fond]?.colorData || colors.white.colorData">{{ forfait.field_internet }}Go</p>
                    </div>

                    <div class="mb-20">
                      <span class="text-bold"><span class="c-orange text-xl leading-24">{{ Number(forfait.field_prix_forfait).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€</span>&nbsp;/mois</span>
                    </div>

                    <div class="text-center">
                      <a @click.prevent="$emit('loadDialog', $event)" :data-forfaitid="forfait.nid" class="block underline hover:no-underline font-bold text-sm py-10 jsModaleBtn" href="javascript:void(0)">Voir en détail</a>
                    </div>
                  </div>

                  <div class="border-t2-grey15 border-t2-grey15--js" :class="`chooseForfaitMultiligne${multiligne}`">
                    <button @click="selectForfaitMultiligne" :data-id="forfait.nid" :data-multiligne="`${multiligne}`" class="hover:bg-orange hover:c-white w-full h-50 text-center pointer text-bold" :class="colors[forfait.field_couleur_de_fond]?.bgBtn || colors.white.bgBtn" type="button">Choisir ce forfait</button>
                  </div>

                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-50" :id="`addforfait${multiligne}`">
      <div class="container dflex justify-center">
        <button @click="addForfait" class="dflex items-center hover:underline pointer addForfait" type="button" :data-multiligne="`${multiligne}`">
          <span class="block c-orange w-18 h-18 p-5 box-content"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M15.3984 7.5146h-4.913v-4.913a.9141.9141 0 0 0-.9141-.9141H8.4287a.9141.9141 0 0 0-.914.914v4.9131H2.6015a.9141.9141 0 0 0-.9141.9141v1.1426c0 .5048.4093.9141.914.9141h4.9131v4.913c0 .5048.4093.9141.9141.9141h1.1426a.9142.9142 0 0 0 .9141-.9141v-4.913h4.913a.9142.9142 0 0 0 .9141-.9141V8.4287a.9141.9141 0 0 0-.9141-.914Z" clip-rule="evenodd"/></svg></span>
          <span class="text-bold">
            {{
              multiligne === 1 ? 'Ajouter un 2e forfait'
              : multiligne === 2 ? 'Ajouter un 3e forfait'
              : multiligne === 3 ? 'Ajouter un 4e forfait'
              : ''
            }}
          </span>
        </button>
      </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { onMounted, nextTick } from 'vue';

const data_etape2 = ref({});
const error_etape2 = ref(null);
const isLoading = ref(true);

defineExpose({
  data_etape2
});

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  multiligne: Number,
  tag: Object
});

const colors = {
  black: { bgClass: 'bg-black c-white poCardFiber', jumperClass: 'gradient-white c-white', bgBtn: 'bg-black c-white', colorSvg: 'c-grey14', bgMobile: 'bg-black c-white', colorData: 'c-orange'},
  grey: { bgClass: 'bg-grey14 c-white', jumperClass: 'gradient-white c-white', bgBtn: 'bg-grey14 c-white', colorSvg: 'c-grey11', bgMobile: 'bg-grey14 c-white', colorData: 'c-white'},
  white: { bgClass: 'bg-white c-black', jumperClass: 'gradient-grey c-black', bgBtn: 'bg-white c-black', colorSvg: 'c-grey15', bgMobile: 'bg-white', colorData: 'c-black'},
}


const sortedForfaits = computed(() => {
  if (!data_etape2.value?.forfaits) return [];

  return Object.values(data_etape2.value.forfaits)
    .sort((a, b) => Number(a.field_poids) - Number(b.field_poids));
});

//const multiligne = ref(props.parcours.multiligne);

//defineEmits(['switchToEtape3']);

const emit = defineEmits(['switchToEtape3','enableSelect','loadMultiligne1','loadMultiligne2','loadMultiligne3','loadMultiligne4','loadDialog']);

function selectForfaitMultiligne(event) {

  //console.log('selectForfaitMultiligne');
  var forfait = event.target;
  if (forfait.classList.contains('bg-white') && forfait.classList.contains('c-black')) {
    forfait.classList.remove("bg-white","c-black");
    forfait.classList.add("bg-orange", "c-white");
  }
  if (forfait.classList.contains('bg-grey14') && forfait.classList.contains('c-white')) {
    forfait.classList.remove("bg-grey14","c-white");
    forfait.classList.add("bg-orange", "c-white");
  }
  if (forfait.classList.contains('bg-black') && forfait.classList.contains('c-white')) {
    forfait.classList.remove("bg-black","c-white");
    forfait.classList.add("bg-orange", "c-white");
  }
  const liParent = forfait.closest('li');
  if (liParent) {
    liParent.classList.add("isSelected");
  }

  forfait.textContent = "Forfait sélectionné";

  //const key = `multiligne${multiligne.value}`; // ex: "multiligne1"
  const key = 'multiligne'+forfait.dataset.multiligne;
  //console.log('Key:'+key);
  if (props.parcours.multilignes[key]) {
    //console.log('OK:'+key+'/'+forfait.dataset.id);
    props.parcours.multilignes[key].forfait = forfait.dataset.id;

    const selected = document.querySelector('input[name="pourQui'+forfait.dataset.multiligne+'"]:checked');
    //console.log('Selected:', selected);
    props.parcours.multilignes[key].who = selected ? selected.value : null;
    emit('incrementRecapKey');
  } else {
    console.warn('Clé multiligne invalide :', key);
  }

  //const bclass = `.chooseForfaitMultiligne${multiligne.value}`;
  const bclass = '.chooseForfaitMultiligne'+forfait.dataset.multiligne;
  var divs = document.querySelectorAll(bclass);
  //console.log('OK:'+bclass);
  divs.forEach(div => {
    //console.log('OK:'+bclass);
    var btn = div.querySelector("button");
    if (btn !== forfait) {
      const parent = btn.parentElement;
      const prevSibling = parent.previousElementSibling;
      btn.classList.remove('bg-orange','c-white','bg-white','c-black','bg-black'); // supprime 'toto' sur tous les autres
      if (prevSibling.classList.contains('bg-white') && prevSibling.classList.contains('c-black')) {
        btn.classList.add("bg-white", "c-black");
      }
      if (prevSibling.classList.contains('bg-grey14') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-grey14", "c-white");
      }
      if (prevSibling.classList.contains('bg-black') && prevSibling.classList.contains('c-white')) {
        btn.classList.add("bg-black", "c-white");
      }
      btn.textContent = "Choisir ce forfait";
      const liParentOther = btn.closest('li');
      if (liParentOther) {
        liParentOther.classList.remove("isSelected");
      }
    }
  });
}

function selectForfaitMultiligneType(event) {


  var forfaittype = event.target;
  var multilignetype = forfaittype.dataset.multiligne;
  //console.log('selectForfaitMultiligneType:' + multilignetype);
  const key = `multiligne${multilignetype}`; // ex: "multiligne1"
  //console.log('Key:'+key);
  if (props.parcours.multilignes[key]) {
    const selected = document.querySelector(`input[name="pourQui${multilignetype}"]:checked`);
    //console.log('Selected:', selected);
    props.parcours.multilignes[key].who = selected ? selected.value : null;
    emit('incrementRecapKey');
  } else {
    //console.warn('Clé multiligne invalide :', key);
  }

}

function addForfait(event) {

  //console.log('addForfait');
  var addforfait = event.target;
  var dmultiligne = addforfait.dataset.multiligne;

  const buttonParent = addforfait.closest('button');
  //console.log('Class:'+buttonParent.getAttribute('class'));
  var buttonmultiligne = buttonParent.dataset.multiligne;
  var nextmultiligne = Number(buttonmultiligne) + 1;
  const addforfaitid = `addforfait${buttonmultiligne}`;
  const addforfaitblock = document.getElementById(addforfaitid);
  addforfaitblock.style.display = "none";
  //console.log('nextmultiligne:'+buttonmultiligne+'/'+nextmultiligne);

  emit(`loadMultiligne${nextmultiligne}`);

}

function deleteForfait(event) {

  //console.log('deleteForfait');
  var deleteforfait = event.target;
  emit('deleteMultiligne'+deleteforfait.dataset.multiligne);

}

onMounted(async () => {
  try {
    const params = new URLSearchParams({
      mobile: props.parcours.mobile,
      multiligne: 1
    });
    const res = await fetch(`/packopenv3/etape2?${params}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape2.value = await res.json();
    await nextTick();
    slidersPoForfait();

    const mid = `multiligne${props.multiligne}`;
    const sliderMultiligne = document.getElementById(mid);

    //console.log('ETAT:' + props.multiligne + '//' + props.parcours.multiligne);
    if (props.multiligne == 4 || (props.multiligne < 3 && props.multiligne < props.parcours.multiligne)) {
      const addforfaitid = `addforfait${props.multiligne}`;
      const addforfaitblock = document.getElementById(addforfaitid);
      addforfaitblock.style.display = "none";
    }
    if (sliderMultiligne) {
      sliderMultiligne.scrollIntoView({
        behavior: 'smooth',  // défilement fluide
        block: 'start'       // aligne en haut de la fenêtre
      });
    }

    // Chercher le bouton dont data-id =
    const forfaittype = props.parcours.multilignes[`multiligne${props.multiligne}`].who;
    //console.log('forfaittype:'+forfaittype)
    if (forfaittype != 0) {

      const mmid = `pourQui2-${props.multiligne}`;
      const radiof = document.querySelector('label[for="'+mmid+'"]');
      //const radiof = document.getElementById(mmid);
      //console.log('ok1');
      if (radiof) {
        //console.log('ok2');
        radiof.click();
      }
    }

    // Chercher le bouton dont data-id =
    const forfaitid = props.parcours.multilignes[`multiligne${props.multiligne}`].forfait;
    const divparent = `div.chooseForfaitMultiligne${props.multiligne}`;
    //console.log('forfaitiddddd:'+forfaitid+'//'+divparent);
    if (forfaitid != 0) {
      const buttonf = document.querySelector(divparent + ' button[data-id="'+forfaitid+'"]');
      if (buttonf) {
        console.log('button');
        buttonf.click();
      }
    }

    const nextmultiligne =  Number(props.multiligne)+1;
    const nextKey = `multiligne${nextmultiligne}`;
    const nextObj = props.parcours.multilignes[nextKey];
    //console.log('nextmultiligne:'+nextKey);

    if (nextObj && nextObj.forfait != 0) {
      emit(`loadMultiligne${nextmultiligne}`);
      const prevforfaitid = `addforfait${props.multiligne}`;
      const prevforfaitblock = document.getElementById(prevforfaitid);
      prevforfaitblock.style.display = "none";
    }

  } catch (e) {
    error_etape2.value = e.message;
  } finally {
    isLoading.value = false;
  }
});



</script>
